import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { propinsiApi, PropinsiListParams } from '@/api/propinsi';
import { Propinsi } from '@/types';
import { useActionFeedback } from '@/hooks/useActionFeedback';

export const usePropinsiList = (params: PropinsiListParams = {}) =>
  useQuery({
    queryKey: ['propinsi', params],
    queryFn: () => propinsiApi.getAll(params),
  });

export const usePropinsiOptions = () =>
  useQuery({
    queryKey: ['propinsi-options'],
    queryFn: () => propinsiApi.getOptions(),
  });

export const useCreatePropinsi = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (data: Partial<Propinsi>) => propinsiApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['propinsi'] });
      queryClient.invalidateQueries({ queryKey: ['propinsi-options'] });
      feedback.success('Provinsi berhasil dibuat');
    },
    onError: (error) => {
      feedback.error('Gagal membuat provinsi', error);
    },
  });
};

export const useUpdatePropinsi = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<Propinsi> }) => propinsiApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['propinsi'] });
      queryClient.invalidateQueries({ queryKey: ['propinsi-options'] });
      feedback.success('Provinsi berhasil diperbarui');
    },
    onError: (error) => {
      feedback.error('Gagal memperbarui provinsi', error);
    },
  });
};

export const useDeletePropinsi = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (id: number) => propinsiApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['propinsi'] });
      queryClient.invalidateQueries({ queryKey: ['propinsi-options'] });
      feedback.success('Provinsi berhasil dihapus');
    },
    onError: (error) => {
      feedback.error('Gagal menghapus provinsi', error);
    },
  });
};
